import {
  LOAD_HELP,
  LOAD_HELP_FAILURE,
  LOAD_HELP_SUCCESS,
} from "./help.actions";
import { withLoadingState } from "../shared/withLoadingState";
import _ from "lodash";

const reducer = (state = {}, action) => {
  switch (action.type) {
    case LOAD_HELP_SUCCESS: {
      return { ...state, sections: action.payload };
    }

    default:
      return state;
  }
};

export const helpReducer = withLoadingState({
  loadActionType: LOAD_HELP,
  successActionType: LOAD_HELP_SUCCESS,
  failureActionType: LOAD_HELP_FAILURE,
})(reducer);

export const getHelp = (state) => state.help;
export const getHelpContent = (state) => getHelp(state).sections;
export const getHelpSections = (state) => {
  const content = getHelpContent(state);

  return _.transform(
    content,
    (sections, section) => {
      if (section.level > 2) {
        return;
      }

      sections.push({ id: section.id, isActive: false });
    },
    []
  );
};
